import React from "react";
const warrantyTerms = [{
  id: 1,
  title: "First Point of Contact",
  description: "In the unlikely event of any issues arising with your roofline installation EPDM rubber roof or any of our services, Five Star must be the first point of contact. This ensures that all concerns are handled directly by our qualified team."
}, {
  id: 2,
  title: "Third-Party Work",
  description: "Any work carried out on the roofline by a third party without prior authorisation from Five Star will immediately void your warranty. This includes inspections, repairs, or alterations."
}, {
  id: 3,
  title: "Warranty Coverage",
  description: "The warranty covers defects in materials and workmanship, provided that Five Star is contacted first for any issues."
}, {
  id: 4,
  title: "Exclusions",
  description: "The warranty does not cover damage caused by unauthorised work, misuse, neglect, or external factors beyond our control (such as severe weather events)."
}];
export default function WarrantyTerms() {
  return <section id="warranty-terms" className="bg-background py-16 md:py-24">
      <div className="container mx-auto px-4">
        <div className="mx-auto max-w-3xl rounded-xl border border-border bg-card p-8 shadow-xl md:p-12">
          <div className="mb-12 text-center">
            <h1 className="font-sans text-3xl font-bold tracking-tight text-foreground md:text-4xl">
              Five Star Roofline Warranty
            </h1>
            <p className="mt-4 font-sans text-lg text-muted-foreground">
              Terms and Conditions
            </p>
          </div>

          <div className="space-y-8">
            {warrantyTerms.map((term, index) => <div key={term.id} data-index={index} className="flex gap-4 md:gap-6">
                <div className="mt-1 shrink-0">
                  <span className="font-sans text-2xl font-bold text-primary md:text-3xl">
                    {term.id}.
                  </span>
                </div>
                <div>
                  <h2 className="mb-2 font-sans text-xl font-bold text-foreground">
                    {term.title}
                  </h2>
                  <p className="font-sans text-lg leading-relaxed text-muted-foreground">
                    {term.description}
                  </p>
                </div>
              </div>)}
          </div>

          <div className="mt-12 border-t border-border pt-8 text-center">
            <p className="font-sans text-lg font-medium leading-relaxed text-foreground">
              By adhering to these terms, your Five Star Roofline warranty remains
              valid and ensures the best possible protection for your installation.
            </p>
          </div>
        </div>
      </div>
    </section>;
}